<div class="alert alert-danger mx-auto my-5" role="alert">
    <h4 class="alert-heading">Error logging in</h4>
    <hr>
    <p>There was an error logging in to your account. Please try again by closing the browser and revisiting this page.</p>
    <p>If the issue persists please raise a request on <a href="https://ithelpdesk.sngbarratt.com">ithelpdesk.sngbarratt.com</a></p>
  </div>
